/**
 * Detects the best matching language based on the browser language
 * @param defaultLanguage Default fallback language
 * @param supportedLanguages List of supported languages
 * @returns Best available language
 */
export function detectBrowserLanguage(defaultLanguage, supportedLanguages) {
    var _a;
    return (_a = findBestMatchingLanguage(supportedLanguages)) !== null && _a !== void 0 ? _a : defaultLanguage;
}
/**
 * Returns the list of supported languages as provided by the browser
 * @returns List of supported browser languages
 */
function getAcceptedLanguages() {
    // @ts-expect-error readonly string[] instead of string[] but whatever
    const rawLanguage = 
    // @ts-expect-error userLanguage is needed for backwars compatibility
    navigator.languages || navigator.language || navigator.userLanguage;
    if (!Array.isArray(rawLanguage)) {
        return [rawLanguage];
    }
    return rawLanguage;
}
/**
 *
 * @param supportedLanguages List of supported languages
 * @returns Closest matching language
 */
function findBestMatchingLanguage(supportedLanguages) {
    const acceptedLanguages = getAcceptedLanguages();
    let bestMatchingLanguage = undefined;
    acceptedLanguages.find((language) => {
        if (supportedLanguages.includes(language)) {
            bestMatchingLanguage = language;
            return true;
        }
        const rawLanguage = language.substr(0, language.indexOf('-'));
        if (language.includes('-')) {
            if (supportedLanguages.includes(rawLanguage)) {
                bestMatchingLanguage = rawLanguage;
                return true;
            }
        }
        return false;
    });
    return bestMatchingLanguage;
}
//# sourceMappingURL=detectBrowserLanguage.js.map